import {
  getReviewsAllPhotos,
  getReviewsPhotosModalCurrentShowed,
  isReviewsPhotosModalShowed,
} from 'features/reviews/selectors';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { Dispatch } from 'redux';
import { PhotosModal, PhotosModalProps } from 'common/components/photos-modal';
import { closePhotosModal, PictureSources, showPhoto } from 'features/reviews';

type ReviewsPhotosModalState = Pick<PhotosModalProps, 'photos' | 'showedPicture' | 'isShowed'>;
type ReviewsPhotosModalProps = Omit<PhotosModalProps, 'atSSR'>;

const ReviewsPhotosModal: React.FC<ReviewsPhotosModalProps> = ({
  breakpoint,
  photos,
  showedPicture,
  isShowed,
  setShowedPicture,
  onCloseModal,
  ...htmlProps
}) => {
  const [atSSR, setAtSSR] = React.useState<boolean>(true);
  React.useEffect(() => setAtSSR(false), []);
  return (
    <PhotosModal
      breakpoint={breakpoint}
      atSSR={atSSR}
      photos={photos}
      showedPicture={showedPicture}
      isShowed={isShowed}
      setShowedPicture={setShowedPicture}
      onCloseModal={onCloseModal}
      data-qa="reviews-photos-modal_mf-pdp"
      {...htmlProps}
    />
  );
};

const mapStoreToProps = (store: RootReducer): ReviewsPhotosModalState => {
  return {
    photos: getReviewsAllPhotos(store),
    isShowed: isReviewsPhotosModalShowed(store),
    showedPicture: getReviewsPhotosModalCurrentShowed(store),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCloseModal: () => dispatch(closePhotosModal()),
  setShowedPicture: (pic: PictureSources | null) => dispatch(showPhoto(pic)),
});

export const PdpReviewsPhotosModal = connect(mapStoreToProps, mapDispatchToProps)(ReviewsPhotosModal);
